export const isProd = true; // <<< prod config
export const MENU_BUCKET = 'netlise-web-menu';
export const GOOGLE_KEY = "AIzaSyAZdW85BVBFMlUcsuJeFphwoTTphB8_U2I";

export const isProdEnv = process.env.NODE_ENV === 'production';

const config = {
  Auth: {
    identityPoolId: "ap-southeast-1:2fb4e791-d71d-4a6f-b424-3b3d0fbf3f1a",
    region: "ap-southeast-1",
    identityPoolRegion: "ap-southeast-1",
    userPoolId: "ap-southeast-1_v2ljou2N2",
    // The dashboard's OWN app client (terraform: aws_cognito_user_pool_client
    // .dashboard). Identical in settings to the shared "netlise-email-client"
    // it replaced, but dedicated — the pool's reCAPTCHA triggers gate this id
    // and no-op for every other caller, so the iPad POS, the mobile app and
    // the chat app keep signing in without a captcha they cannot render.
    // Do not point another app at it.
    userPoolWebClientId: "1l0c5dchhgo82027vu4dl04lia",
    mandatorySignIn: false,
    authenticationFlowType: "USER_PASSWORD_AUTH",
    oauth: {
      domain: "netlise-app.auth.ap-southeast-1.amazoncognito.com",
      scope: [
        "email",
        "profile",
        "openid",
      ],
      redirectSignIn: isProdEnv ? "https://dashboard.netlise.com" : "http://localhost:3001",
      redirectSignOut: isProdEnv ? "https://dashboard.netlise.com" : "http://localhost:3001",
      responseType: "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
      "EMAIL"
    ],
    "aws_cognito_social_providers": [
      "FACEBOOK",
      "GOOGLE",
      "APPLE"
    ],
    "aws_cognito_signup_attributes": [
      "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
      "SMS"
    ],
    "aws_cognito_password_protection_settings": {
      "passwordPolicyMinLength": 8,
      "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
      "EMAIL"
    ]
  },
  aws_appsync_graphqlEndpoint:
    "https://r5denx53k5evvawmy6c3wmf22q.appsync-api.ap-southeast-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-southeast-1",
  aws_appsync_authenticationType: "AWS_IAM",
  // POS real-time order notifications (separate AppSync API)
  // Update this value with the output of: terraform output pos_realtime_appsync_endpoint
  pos_realtime_appsync_endpoint: process.env.REACT_APP_POS_APPSYNC_ENDPOINT || "",
  pos_realtime_appsync_region:   "ap-southeast-1",
  API: {
    region: "ap-southeast-1",
    endpoints: [
      {
        id: "7aqkhkggh5",
        name: "dev-netlise-app-api",
        description: "",
        endpoint:
          "https://7aqkhkggh5.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
      {
        id: "ik1md8pcjk",
        name: "dev-netlise-api-v2",
        description: "",
        endpoint:
          "https://ik1md8pcjk.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
      {
        id: "4qawsqx576",
        name: "dev-admin-dashboard-api",
        description: "",
        endpoint:
          "https://4qawsqx576.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
      {
        id: "rvmipj7w17",
        name: "netlise-report-api-dev",
        description: "",
        endpoint:
          "https://rvmipj7w17.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
      {
        id: "ud533hc40f",
        name: "dev-nl-dashboard-api",
        description: "new client api for the course",
        endpoint:
          "https://ud533hc40f.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
      {
        id: "xx0nocdla5",
        name: "payment-apis-dev",
        description: "",
        endpoint:
          "https://xx0nocdla5.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
      {
        id: "mj8lxajnve",
        name: "dev-netlise-pos-lambda-api",
        description: "global ",
        endpoint:
          "https://mj8lxajnve.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
    ],
  },
  Storage: {
    AWSS3: {
      bucket: "netlise-app-bucket",
      region: "ap-southeast-1",
    },
  },
};

const prodConfig = {
  Auth: {
    identityPoolId: "ap-southeast-1:2fb4e791-d71d-4a6f-b424-3b3d0fbf3f1a",
    region: "ap-southeast-1",
    identityPoolRegion: "ap-southeast-1",
    userPoolId: "ap-southeast-1_v2ljou2N2",
    // The dashboard's OWN app client (terraform: aws_cognito_user_pool_client
    // .dashboard). Identical in settings to the shared "netlise-email-client"
    // it replaced, but dedicated — the pool's reCAPTCHA triggers gate this id
    // and no-op for every other caller, so the iPad POS, the mobile app and
    // the chat app keep signing in without a captcha they cannot render.
    // Do not point another app at it.
    userPoolWebClientId: "1l0c5dchhgo82027vu4dl04lia",
    mandatorySignIn: false,
    authenticationFlowType: "USER_PASSWORD_AUTH",
    oauth: {
      domain: "netlise-app.auth.ap-southeast-1.amazoncognito.com",
      scope: [
        "email",
        "profile",
        "openid",
      ],
      redirectSignIn: isProdEnv ? "https://dashboard.netlise.com" : "http://localhost:3001",
      redirectSignOut: isProdEnv ? "https://dashboard.netlise.com" : "http://localhost:3001",
      responseType: "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
      "EMAIL"
    ],
    "aws_cognito_social_providers": [
      "FACEBOOK",
      "GOOGLE",
      "APPLE"
    ],
    "aws_cognito_signup_attributes": [
      "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
      "SMS"
    ],
    "aws_cognito_password_protection_settings": {
      "passwordPolicyMinLength": 8,
      "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
      "EMAIL"
    ]
  },
  aws_appsync_graphqlEndpoint:
    "https://r5denx53k5evvawmy6c3wmf22q.appsync-api.ap-southeast-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-southeast-1",
  aws_appsync_authenticationType: "AWS_IAM",
  // POS real-time order notifications (separate AppSync API)
  // Update this value with the output of: terraform output pos_realtime_appsync_endpoint
  pos_realtime_appsync_endpoint: process.env.REACT_APP_POS_APPSYNC_ENDPOINT || "",
  pos_realtime_appsync_region:   "ap-southeast-1",
  API: {
    region: "ap-southeast-1",
    endpoints: [
      {
        id: "7aqkhkggh5",
        name: "dev-netlise-app-api",
        description: "",
        endpoint:
          "https://7aqkhkggh5.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
      {
        id: "ik1md8pcjk",
        name: "dev-netlise-api-v2",
        description: "",
        endpoint:
          "https://ik1md8pcjk.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
      {
        id: "4qawsqx576",
        name: "dev-admin-dashboard-api",
        description: "",
        endpoint:
          "https://4qawsqx576.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
      {
        id: "rvmipj7w17",
        name: "netlise-report-api-dev",
        description: "",
        endpoint:
          "https://rvmipj7w17.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
      {
        id: "ud533hc40f",
        name: "dev-nl-dashboard-api",
        description: "new client api for the course",
        endpoint:
          "https://ud533hc40f.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
      {
        id: "xx0nocdla5",
        name: "payment-apis-dev",
        description: "",
        endpoint:
          "https://xx0nocdla5.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
      {
        id: "mj8lxajnve",
        name: "dev-netlise-pos-lambda-api",
        description: "global ",
        endpoint:
          "https://mj8lxajnve.execute-api.ap-southeast-1.amazonaws.com/dev",
        region: "ap-southeast-1",
        paths: [],
      },
    ],
  },
  Storage: {
    AWSS3: {
      bucket: "netlise-app-bucket",
      region: "ap-southeast-1",
    },
  },
};

export default isProd ? prodConfig : config;
